import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=67840b02&scoped=true&"
import script from "./breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumbs.vue?vue&type=style&index=0&id=67840b02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67840b02",
  null
  
)

export default component.exports